<template>
  <!--  -->
   <span>
      {{ formatedTime }}
   </span>
        <!--  -->
</template>

<script>

export default {
name:"dateformat",
data() {
return {
      formatedTime:"-",
};
},
components:{
//    
},
props: {
  datetime: {
    type: String,
    required: true
  }
},
methods:{
  formatDateTimeToAMPM() {
    const date = new Date(this.datetime);
    console.log(date);
    
    const options = { hour12: true, year:'numeric', month:'short', day:'2-digit', hour: 'numeric', minute: 'numeric' };
    this.formatedTime = date.toLocaleString('en-US', options);
  },
},

mounted() {
  this.formatDateTimeToAMPM();
},

}
</script>
